import styled from "styled-components";

export const Container = styled.div`
  background-color: ${(props) => props.theme.colors.white};
  align-items: flex-start;
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  font-size: 1.4rem;
  height: 100vh;
  padding: 0 5rem 5rem 5rem;
  width: 42rem;

  .submitButton {
    align-items: center;
    display: flex;
    flex-direction: column;
    margin-top: 2rem;
    width: 100%;
  }
`;

export const DispatcherInfo = styled.div`
  background-color: rgba(255, 255, 254, 1);
  font-size: 1.8rem;
  margin-bottom: 2.6rem;
  padding-bottom: 2rem;
  padding-top: 6rem;
  width: 100%;

  p {
    margin: 0;
  }

  .dispatcher-id {
    color: ${(props) => props.theme.colors.primaryBlue};
    font-weight: 600;
  }

  .dispatcher-name {
    font-weight: 800;
    margin-bottom: 1.2rem;
    margin-top: 0.5rem;
    width: 30rem;
  }
`;

interface IStatusDiv {
  status?: string;
}
export const StatusDiv = styled.div<IStatusDiv>`
  ${(props) => {
    const status = props.status.toLowerCase();
    let color, backgroundColor;
    if (status === "problem") {
      color = props.theme.colors.supportRed;
      backgroundColor =
        props.theme.colors.supportRed + props.theme.transparencies.p10;
    } else if (status === "warning") {
      color = props.theme.colors.blackTextBody;
      backgroundColor =
        props.theme.colors.supportYellow + props.theme.transparencies.p30;
    } else if (status === "ok") {
      color = props.theme.colors.betterGreen;
      backgroundColor =
        props.theme.colors.betterGreen + props.theme.transparencies.p10;
    } else {
      color = props.theme.colors.gray;
      backgroundColor =
        props.theme.colors.gray72 + props.theme.transparencies.p20;
    }
    return `
      span {
        background-color: ${backgroundColor};
        color: ${color};
        font-size: 1.1rem;
        font-weight: 600;
        padding: 0.6rem;
      }
      width: 30rem;
  `;
  }}
`;

export const DetailInfo = styled.div`
  display: grid;
  grid-template: 1fr / repeat(2, 1fr);
  width: 100%;

  p {
    margin: 0;
  }

  div {
    margin-bottom: 3.2rem;
  }

  .info-label {
    color: ${(props) =>
      props.theme.colors.blackTextBody + props.theme.transparencies.p30};
    font-size: 1.4rem;
    font-weight: 700;

    margin-bottom: 0.8rem;
  }

  .info-text {
    color: ${(props) => props.theme.colors.blackTextBody};
    font-weight: 500;
    font-size: 1.6rem;
  }
`;

export const VolantesInfo = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  font-weight: 500;
  width: 100%;

  h1 {
    align-self: left;
    font-size: 1.4rem;
    font-weight: 700;
    margin-bottom: 1.6rem;
  }
`;

export const VolanteCard = styled.div`
  align-items: center;
  border-radius: 1rem;
  box-shadow: 0px 5px 50px rgb(231 231 234 / 62%);
  box-sizing: border-box;
  display: flex;
  height: 100%;
  justify-content: space-between;
  margin-bottom: 0.8rem;
  padding: 0.5rem 1.4rem;
  width: 100%;

  .volante-detail {
    margin-right: 1rem;
  }
`;

export const VehiclesInfo = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  margin-top: 3.6rem;
  width: 100%;

  h1 {
    align-self: left;
    font-size: 1.4rem;
    font-weight: 700;
    margin-bottom: 1.6rem;
  }

  .vehicle-label {
    color: ${(props) =>
      props.theme.colors.blackTextBody + props.theme.transparencies.p30};
    font-size: 1.2rem;
    font-weight: 700;
    margin-bottom: 0.6rem;
  }
`;

export const VehicleCard = styled.div`
  color: ${(props) => props.theme.colors.gray72};
  border-radius: 0.8rem;
  border: solid 1px;
  display: grid;
  font-weight: 500;
  grid-template: 1fr;
  margin-bottom: 0.8rem;
  padding-left: 1rem;
  padding: 0.8rem 1.6rem 1.7rem 1.6rem;
  width: 100%;

  p {
    color: black;
    margin: 0;
  }

  .driver-name-container {
    margin-top: 1rem;
  }
`;

export const VehicleRow = styled.div`
  ${(props) => `
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  align-items: center;
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-top: 1rem;

  .vehicle-type {
    margin-right: 1.5rem;
  }

  .info-label {
    color: ${(props) => props.theme.colors.gray};
    font-weight: 600;
    margin-bottom: 0.8rem;
  }
`;

export const CloseButton = styled.button`
  all: unset;
  cursor: pointer;
  margin-left: 38rem;
  margin-top: -2rem;
  top: 0;
  zoom: 1.1;
`;

export const AppointmentInfo = styled.div`
  overflow-y: auto;
`;

export const Text = styled.p`
  ${({ theme }) => `
    color: ${theme.colors.blackTextBody};
    font-size: 1.4rem;
  `}
  font-weight: 500;
`;

export const BoldText = styled.p`
  ${({ theme }) => `
    color: ${theme.colors.blackTextTitle};
  `}
  font-size: 1.5rem;
  font-weight: bold;
`;

export const SectionTitle = styled.h3`
  ${({ theme }) => `
    color: ${theme.colors.blackTextBody + theme.transparencies.p30};
    font-size: 1.2rem;
  `}
  font-weight: 700;
`;
